
import { Col, Container, Row } from "reactstrap";
import { GetInTouch } from "../../../constants";
import { ContactBoxData, TouchContent } from "../../../data/pages/Other";
import { routes } from "../../../routers/routes";
import Breadcrumbs from "../../commonComponents/breadcrumbs";
import CommonHeader from "../../home/common/CommonHeader";
import ContactForm from "./common/ContactForm";
import { dynamicImage, Image } from "../../../utils";

const ContactUs2Container = () => {
  return (
    <>
      <Breadcrumbs title="Contact Us" url={routes.Home.CarDemo1} mainClass="page-breadcrumbs-section" />
      <section className="contact-section contact-2-section">
        <Container>
          <Row className="gy-xl-0 gy-4 justify-content-center">
            {ContactBoxData.map((item, index) => (
              <Col xl={3} lg={4} sm={6} key={index}>
                <li className="contact-box">
                  <div className="contact-icon">{item.icon}</div>
                  <div className="contact-info">
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                </li>
              </Col>
            ))}
          </Row>
          <Row className="gy-lg-0 gy-4 section-t-md-space">
            <Col lg={6}>
              <div className="contact-img">
                <Image src={dynamicImage("other/contact.jpg")} alt="1.jpg" className="img-fluid" />
              </div>
            </Col>
            <Col lg={6}>
              <div className="form-box">
                <CommonHeader title={GetInTouch} content={TouchContent} headClass="content-title text-center" contentClass="mx-0 w-100" />
                <ContactForm />
              </div>
            </Col>
          </Row>
        </Container>
        <div className="section-t-md-space">
          <div className="contact-map height-map">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27404.108970975958!2d-74.15219533827555!3d40.573765671825385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2sin!4v1712811360770!5m2!1sen!2sin" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="map" />
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUs2Container;
